import React from 'react';
import PropTypes from 'prop-types';

import FeedbackEmail from './components/FeedbackEmail/FeedbackEmail';
import FeedbackApproved from './components/FeedbackApproved/FeedbackApproved';

function RegistrationStatus({
  prospectEmail,
  analysed,
  isOpenForm,
}) {
  const { analysisResult, prospect } = analysed;

  return (analysisResult && ('template' in analysisResult)) ? (
    <FeedbackApproved
      template={analysisResult.template}
      prospect={prospect}
    />
  ) : (
    <FeedbackEmail
      email={prospectEmail}
      isOpenForm={isOpenForm}
    />
  );
}

RegistrationStatus.defaultProps = {
  analysed: false,
  isOpenForm: false,
};

RegistrationStatus.propTypes = {
  analysed: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.object,
  ]),
  isOpenForm: PropTypes.bool,
  prospectEmail: PropTypes.string.isRequired,
};

export default RegistrationStatus;
